( function () {
	// Create the measurement node
	var scrollDiv = document.createElement( 'div' );
	scrollDiv.style.width = '100px';
	scrollDiv.style.height = '100px';
	scrollDiv.style.overflow = 'scroll';
	scrollDiv.style.position = 'absolute';
	scrollDiv.style.top = '-9999px';
	document.body.appendChild( scrollDiv );

	// Get the scrollbar width
	var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	
	// Delete the DIV 
	document.body.removeChild( scrollDiv );
	
	var styleTag = document.createElement( 'style' );
	styleTag.innerHTML = ':root { --scrollbar-width: ' + scrollbarWidth + 'px; }';
	document.head.appendChild( styleTag );
} )();
